import { gql } from '@apollo/client';
const GET_ORDER_COMPONENT_VARIANT_STATS = gql `
  query GetOrderComponentVariantStats($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        componentVariantStats {
          totalComponentVariants
          delayedCount
          completelyDeliveredCount
          withPlannedCount
          plannedDelayedCount
          productionDelayedCount
        }
      }
    }
  }
`;
export default GET_ORDER_COMPONENT_VARIANT_STATS;
